//angular imports
import { HTTP_INTERCEPTORS } from '@angular/common/http';

//third party imports
import {
    MSAL_GUARD_CONFIG,
    MSAL_INSTANCE,
    MSAL_INTERCEPTOR_CONFIG,
    MsalBroadcastService,
    MsalGuard,
    MsalInterceptor,
    MsalService
} from '@azure/msal-angular';

//local imports
import { AuthService } from './auth.service';
import { SecurityCommandServices } from './commands';
import { SecurityHelperServices } from './helpers';
import { SecurityRepositoryServices } from './repositories';
import { MsalConfigService, SecurityDomainServices } from './services';

export * from './auth.service';
export * from './commands';
export * from './helpers';
export * from './repositories';
export * from './services';

export const SecurityServices = [
    ...SecurityCommandServices,
    ...SecurityDomainServices,
    ...SecurityHelperServices,
    ...SecurityRepositoryServices,
    AuthService,
    {
        provide: HTTP_INTERCEPTORS,
        useClass: MsalInterceptor,
        multi: true
    },
    {
        provide: MSAL_INSTANCE,
        useFactory: (security: MsalConfigService) => {
            return security.MSALInstanceFactory();
        },
        deps: [MsalConfigService]
    },
    {
        provide: MSAL_GUARD_CONFIG,
        useFactory: (security: MsalConfigService) => {
            return security.MSALGuardConfigFactory();
        },
        deps: [MsalConfigService]
    },
    {
        provide: MSAL_INTERCEPTOR_CONFIG,
        useFactory: (security: MsalConfigService) => {
            return security.MSALInterceptorConfigFactory();
        },
        deps: [MsalConfigService]
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService
]